import { render, staticRenderFns } from "./HelpDesk.vue?vue&type=template&id=71b0929c&scoped=true"
import script from "./HelpDesk.vue?vue&type=script&lang=js"
export * from "./HelpDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0929c",
  null
  
)

export default component.exports